import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth
export const authAPI = {
  login: (data) => api.post('/auth/login', data),
  register: (data) => api.post('/auth/register', data),
  getMe: () => api.get('/auth/me'),
  updateMe: (data) => api.put('/auth/me', data),
  changePassword: (data) => api.post('/auth/change-password', data),
};

// Income
export const incomeAPI = {
  getAll: (params) => api.get('/incomes', { params }),
  create: (data) => api.post('/incomes', data),
  update: (id, data) => api.put(`/incomes/${id}`, data),
  delete: (id) => api.delete(`/incomes/${id}`),
  getCategories: () => api.get('/incomes/categories'),
};

// Expense
export const expenseAPI = {
  getAll: (params) => api.get('/expenses', { params }),
  create: (data) => api.post('/expenses', data),
  update: (id, data) => api.put(`/expenses/${id}`, data),
  delete: (id) => api.delete(`/expenses/${id}`),
  getCategories: () => api.get('/expenses/categories'),
};

// Maaser
export const maaserAPI = {
  getSummary: (params) => api.get('/maaser/summary', { params }),
  getPayments: (params) => api.get('/maaser/payments', { params }),
  addPayment: (data) => api.post('/maaser/payments', data),
  deletePayment: (id) => api.delete(`/maaser/payments/${id}`),
};

// Admin
export const adminAPI = {
  getUsers: () => api.get('/admin/users'),
  getUserDetail: (id) => api.get(`/admin/users/${id}`),
  toggleActive: (id) => api.post(`/admin/users/${id}/toggle-active`),
  toggleAdmin: (id) => api.post(`/admin/users/${id}/toggle-admin`),
  deleteUser: (id) => api.delete(`/admin/users/${id}`),
  getStats: () => api.get('/admin/stats'),
};

export default api;
